module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": _vm.message,
      "size": 'relative',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.typeConfirm) ? _c('body', {
    staticClass: "px-7 pt-7 pb-4 flex-grow overflow-y-auto bg-white",
    staticStyle: {
      "min-height": "95px",
      "background-color": "white"
    }
  }, [(!_vm.isSaving) ? _c('pl-input', {
    staticStyle: {
      "padding": "0 28px"
    },
    attrs: {
      "errorMessage": _vm.errorMessage,
      "labelText": _vm.labelText
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.confirmMessage),
      callback: function($$v) {
        _vm.confirmMessage = $$v
      },
      expression: "confirmMessage"
    }
  }) : _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1)], 1) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "w-full center text-sm py-4 bg-white rounded-b inline-flex justify-center my-3",
    class: !_vm.typeConfirm ? 'items-center' : 'mt-0',
    staticStyle: {
      "min-height": "52px"
    }
  }, [_c('button', {
    staticClass: "bg-gray-100 hover:bg-gray-200 py-2 px-7 font-semibold text-gray-600 rounded mr-2",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "py-2 px-6 font-semibold rounded text-white",
    class: _vm.confirmColor,
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n      " + _vm._s(_vm.confirmText) + "\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3e28cbe2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plDialog/plDialogConfirm.vue
// module id = 2226
// module chunks = 61